import { ref } from 'vue';
import { interceptors } from '@/Utils/api';
import { versionEmitter } from '@/Utils/graphqlAPI';
import { extractFrontendCommitHash } from '@/Utils/versionUtils';
import { log } from '@/Utils/logger';

const isUpToDate = ref(true);

const currentVersion = extractFrontendCommitHash(import.meta.env.VITE_BUILD_VERSION ?? 'unknown');

function versionHandler(version: string) {
  if (!isUpToDate.value || currentVersion === version || import.meta.env.DEV) {
    return;
  }
  console.log('New version detected!', { currentVersion, newVersion: version });
  log.info(
    {
      func: 'versionHandler',
      currentVersion,
      newVersion: version,
    },
    'New version detected!',
  );

  isUpToDate.value = false;
  interceptors.response.eject(interceptorId);
  versionEmitter.off('version', versionHandler);
}

// Add an axios response interceptor to check for X-Version headers from the API server.
const interceptorId = interceptors.response.use(
  (res) => {
    try {
      const version = res.headers['x-version'];
      if (typeof version == 'string') {
        versionHandler(extractFrontendCommitHash(version));
      }
    } catch (err) {
      console.error(err);
    }
    return res;
  },
  (err) => {
    return Promise.reject(err);
  },
);

// Do the same with Apollo HTTP requests.
versionEmitter.on('version', versionHandler);

export const useIsUpToDate = () => {
  return {
    isUpToDate,
  };
};
